import { getExternalUrlPageWithEnv } from '../utils/env';

export const SERVICES_URL = getExternalUrlPageWithEnv("SERVICES", "HOME");

export const SERVICES_APP_URL = getExternalUrlPageWithEnv("SERVICES_APP", "HOME");

export const CASH_URL = getExternalUrlPageWithEnv("CASH", "HOME")

export const MAP_URL = getExternalUrlPageWithEnv("MAP", "HOME")

export const MARKET_PLACE_URL = getExternalUrlPageWithEnv("MARKET_PLACE", "HOME");